
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class MergingBOMGrid extends Serenity.EntityGrid<MergingBOMRow, any> {
        protected getColumnsKey() { return 'Production.MergingBOM'; }
        protected getDialogType() { return MergingBOMDialog; }
        protected getIdProperty() { return MergingBOMRow.idProperty; }
        protected getInsertPermission() { return MergingBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return MergingBOMRow.localTextPrefix; }
        protected getService() { return MergingBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}